import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import type { FetchResult, MutationResult } from '@apollo/client';

import { showErrorAction, showMessageAction } from 'containers/Notification/actions';
import { MutationMutationUpsertActionArgs, useUpsertActionMutation } from 'generated/graphql';

export const useActionMutation = (
  actionId?: string
): [(data: MutationMutationUpsertActionArgs) => void, MutationResult] => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onCompleted: Exclude<
    Parameters<typeof useUpsertActionMutation>[0],
    undefined
  >['onCompleted'] = () => {
    dispatch(showMessageAction(actionId ? 'Action updated' : 'Action created'));
    history.push('/deeds/actions');
  };

  const onError = () => {
    dispatch(
      showErrorAction(
        `An error occurred while ${actionId ? 'saving' : 'updating'} your action, please try again`
      )
    );
  };

  const [upsertActionMutation, result] = useUpsertActionMutation({
    onCompleted,
    onError,
    update: (cache) => {
      cache.evict({ id: 'ROOT_QUERY', fieldName: 'actions' });
    },
  });

  const mutation = (data: MutationMutationUpsertActionArgs): Promise<FetchResult> =>
    upsertActionMutation({
      variables: data,
    });

  return [mutation, result];
};
